<template lang="html">

  <div>

    <section class="mas-informacion row-center ais" :nomargin="nomargin" v-if="$route.name != 'civsem'" >

        <div class="imagen">

        </div>

        <div class="texto column-center">
    
            <h2>¿Quieres más información?</h2>
            <p>Puedes ponerte en contacto con nosotros aquí</p>

            <router-link :to="$t('enlaces.contacto')" class="btn">Contactar</router-link>

        </div>

    </section>

    
    <footer class="footer">
      
      <div class="container row-between">
        
        <img src="/static/img/logo-fundacion.svg" alt="Logo fundación" class="logo">
        
        <div class="contenedor-enlaces row-end">
          <router-link :to="$t('enlaces.aviso_legal')">Aviso legal</router-link>
          <router-link :to="$t('enlaces.politica_privacidad')">Política de privacidad</router-link>
          <router-link :to="$t('enlaces.politica_cookies')">Política de cookies</router-link>
          <router-link v-if="isLogged" :to="$t('enlaces.areainterna')">Mi perfil</router-link>
          <!-- <router-link v-else :to="$t('enlaces.registro')">Registrate</router-link> -->
          <a class="optanon-show-settings">Ajustes de cookies</a>
        </div>
        
      </div>
      
    </footer>
    
  </div>

</template>

<script lang="js">


  import {mapGetters} from 'vuex'

  export default  {
    name: 'app-footer',
    computed:{
      ...mapGetters({
        version : 'getVersion',
        isLogged : 'getLogged'
      }),
      nomargin(){
        let names = ['fundadores', 'fundacion','contacto','civsem'];
      
        return names.some(e => (e = this.$route.name));
      }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/parts/footer.vue